import { useEffect, useState } from "react";
import { http } from "../lib/api";
import { useDataset, DatasetSelect, Tabs, PageHead, CorteBadge } from "../lib/lm";
import { Bandeja, Solicitudes, Tablero } from "../components/cob/CobParts";
import { LoanFicha } from "../components/lm/LoanFicha";
import { useCopilotoFiltros } from "../lib/copiloto";

export default function CobranzaInt() {
  const { info, ds, setDs } = useDataset();
  const [tab, setTab] = useState("bandeja");
  useCopilotoFiltros("cobranza", (p) => setTab(p === null ? "bandeja" : p.tab || p.vista || tab), { pestana: tab, vista: "Cobranza" });
  const [users, setUsers] = useState([]);
  const [sel, setSel] = useState(null);
  useEffect(() => { http.get("/tasks/members").then((r) => setUsers(r.data)).catch(() => {}); }, []);
  return (
    <main className="mx-auto max-w-7xl space-y-6 px-4 py-8 sm:px-6 lg:px-10" data-testid="cobranza-int-page" style={{ animation: "rise .35s ease-out both" }}>
      <PageHead kicker="Gestión interna · sin recordatorios al cliente" title="Cobranza"><CorteBadge iso={info?.cortes?.[ds]} testid="cob-corte" /><DatasetSelect info={info} ds={ds} setDs={setDs} /></PageHead>
      <Tabs tabs={[["bandeja", "Bandeja"], ["solicitudes", "Solicitudes y firmas"], ["tablero", "Tablero"]]} tab={tab} setTab={setTab} />
      {info && tab === "bandeja" && <Bandeja ds={ds} users={users} onOpen={setSel} key={`b-${ds}`} />}
      {info && tab === "solicitudes" && <Solicitudes ds={ds} key={`s-${ds}`} />}
      {info && tab === "tablero" && <Tablero ds={ds} key={`t-${ds}`} />}
      {sel && <LoanFicha ds={ds} id={sel} onClose={() => setSel(null)} />}
    </main>
  );
}
